import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionIcon, Button, Divider, Group, MultiSelect, NumberInput, Popover, TextInput, } from "@mantine/core";
import { DatePicker, DateRangePicker } from "@mantine/dates";
import { useState } from "react";
import { MdFilterList } from "react-icons/md";
var TableFilter = function (props) {
    var _a, _b, _c, _d;
    var _e = useState(false), opened = _e[0], setOpened = _e[1];
    var _f = useState(((_a = props.currentParam) === null || _a === void 0 ? void 0 : _a.value) || undefined), value = _f[0], setValue = _f[1];
    var _g = useState(((_b = props.currentParam) === null || _b === void 0 ? void 0 : _b.values) || undefined), values = _g[0], setValues = _g[1];
    var _h = useState(((_c = props.currentParam) === null || _c === void 0 ? void 0 : _c.dateFrom) || undefined), dateFrom = _h[0], setDateFrom = _h[1];
    var _j = useState(((_d = props.currentParam) === null || _d === void 0 ? void 0 : _d.dateTo) || undefined), dateTo = _j[0], setDateTo = _j[1];
    var clearFilterValues = function () {
        switch (props.filterConfig.type) {
            case "select":
                setValues(undefined);
                break;
            case "dateRange":
                setDateFrom(undefined);
                setDateTo(undefined);
                break;
            case "date":
                setDateFrom(undefined);
                break;
            case "number":
            case "text":
            default:
                setValue(undefined);
                break;
        }
        props.onClearFilter(props.filterConfig.field);
        setOpened(false);
    };
    var updateFilterParams = function () {
        switch (props.filterConfig.type) {
            case "select":
                props.onChangeFilter({
                    type: props.filterConfig.type,
                    field: props.filterConfig.field,
                    parentRelationField: props.filterConfig.parentRelationField,
                    values: values,
                });
                break;
            case "date":
            case "dateRange":
                props.onChangeFilter(__assign(__assign({}, props.filterConfig), { dateFrom: dateFrom, dateTo: dateTo }));
                break;
            case "number":
            case "text":
            default:
                props.onChangeFilter(__assign(__assign({}, props.filterConfig), { value: value }));
                break;
        }
        setOpened(false);
    };
    var renderFilterInputs = function () {
        switch (props.filterConfig.type) {
            case "select":
                return (_jsx(MultiSelect, { data: props.filterConfig.options || [], value: values, onChange: function (values) { return setValues(values); } }));
            case "date":
                return (_jsx(DatePicker, { placeholder: "Select Date", label: "Search Date", radius: "xl", firstDayOfWeek: "sunday", 
                    //dropdownType="modal"
                    value: dateFrom, onChange: function (value) {
                        setDateFrom(value ? new Date(value.setHours(0, 0, 0, 0)) : undefined);
                        setDateTo(value ? new Date(value.setHours(23, 59, 59, 999)) : undefined);
                    } }));
            case "dateRange":
                return (_jsx(DateRangePicker, { placeholder: "Select Date", label: "Search Date", radius: "xl", firstDayOfWeek: "sunday", dropdownType: "modal", value: [dateFrom || null, dateTo || null], onChange: function (value) {
                        setDateFrom(value[0] ? new Date(value[0].setHours(0, 0, 0, 0)) : undefined);
                        setDateTo(value[1]
                            ? new Date(value[1].setHours(23, 59, 59, 999))
                            : undefined);
                    } }));
            case "number":
                return (_jsx(NumberInput, { "data-autofocus": true, defaultValue: 18, label: "Search Value", radius: "xl", hideControls: true, value: value ? parseInt(value) : undefined, onChange: function (value) { return setValue("".concat(value)); } }));
            case "text":
            default:
                return (_jsx(TextInput, { "data-autofocus": true, size: "xs", value: value, onChange: function (e) { return setValue(e.currentTarget.value); } }));
        }
    };
    var headerColor = props.headerColor
        ? "rgb(".concat(props.headerColor.r, ", ").concat(props.headerColor.g, ", ").concat(props.headerColor.b, ") !important")
        : undefined;
    return (_jsxs(Popover, __assign({ width: 300, position: "bottom", withArrow: true, trapFocus: true, shadow: "md", closeOnClickOutside: props.filterConfig.type != "date" &&
            props.filterConfig.type != "dateRange", opened: opened, onChange: setOpened }, { children: [_jsx(Popover.Target, { children: _jsx(ActionIcon, __assign({ onClick: function () { return setOpened(function (prev) { return !prev; }); }, color: "gray", sx: {
                        color: headerColor,
                        "&:hover": {
                            color: props.headerBg,
                            backgroundColor: props.headerColor
                                ? "rgba(".concat(props.headerColor.r, ", ").concat(props.headerColor.g, ", ").concat(props.headerColor.b, ", 0.75) !important")
                                : undefined,
                        },
                    } }, { children: _jsx(MdFilterList, { size: 20, color: props.currentParam ? 'tomato' : 'gray' }) })) }), _jsxs(Popover.Dropdown, { children: [renderFilterInputs(), _jsx(Divider, { my: "sm" }), _jsxs(Group, __assign({ position: "apart" }, { children: [_jsx(Button, __assign({ variant: "outline", color: "red", radius: "lg", compact: true, uppercase: true, onClick: function () { return clearFilterValues(); } }, { children: "Clear" })), _jsx(Button, __assign({ radius: "lg", compact: true, uppercase: true, onClick: function () { return updateFilterParams(); } }, { children: "Search" }))] }))] })] })));
};
export default TableFilter;
